import { Box, useMediaQuery } from '@mui/material';
import ProfileSidebarMenu from './PrifileSidebarMenu';
import ProfileSidebarProgress from './ProfileSidebarProgress';
import { useThemeContext } from '../../../theme/ThemeContextProvider';
import UserBadges from '../../../pages/auth/ProfilePage/UserBadges/UserBadges';

const ProfileSidebar = () => {
  const { theme } = useThemeContext();
  const mobileView = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={mobileView ? '0' : '22px'}
      width={{ xs: '100%', lg: 252, xl: 314 }}
    >
      {!mobileView && <ProfileSidebarMenu />}
      <ProfileSidebarProgress />
      <UserBadges />
    </Box>
  );
};

export default ProfileSidebar;
